// removed by extract-text-webpack-plugin
module.exports = {"date-line":"style__date-line___3iTfW"};


//////////////////
// WEBPACK FOOTER
// ./components/EventSummaryDateLine/style.scss
// module id = 1209
// module chunks = 0